import { useEffect, useState } from "react";

export const defaultStorage = { 'mTime': 0, 'debug': false, 'nPrime': true, 'nTeam': true, 'nDirect': true, 'sPrime': true, 'sTeam': true, 'sDirect': true };
export const useLocalStorage = (key) => {
	const [storedValue, setStoredValue] = useState(defaultStorage);
	useEffect(() => {
		const item = window.localStorage.getItem(key);
		let pItem;
		try {
			pItem = JSON.parse(item);
			if (typeof pItem.mTime === 'number' && typeof pItem.debug === 'boolean'
				&& typeof pItem.nPrime === 'boolean' && typeof pItem.nTeam === 'boolean' && typeof pItem.nDirect === 'boolean'
				&& typeof pItem.sPrime === 'boolean' && typeof pItem.sTeam === 'boolean' && typeof pItem.sDirect === 'boolean') {
				setStoredValue({...pItem});
			}
			else {
				setStoredValue({...defaultStorage});
				window.localStorage.setItem(key, JSON.stringify({...defaultStorage}));
			}
		}
		catch (e) {
			setStoredValue({...defaultStorage});
			window.localStorage.setItem(key, JSON.stringify({...defaultStorage}));
		}
	}, [key]);
	const setValue = (value) => {
		if (typeof value.mTime === 'number' && typeof value.debug === 'boolean'
			&& typeof value.nPrime === 'boolean' && typeof value.nTeam === 'boolean' && typeof value.nDirect === 'boolean'
			&& typeof value.sPrime === 'boolean' && typeof value.sTeam === 'boolean' && typeof value.sDirect === 'boolean') {
			setStoredValue(value);
			window.localStorage.setItem(key, JSON.stringify(value));
		}
		else {
			setStoredValue({...defaultStorage});
			window.localStorage.setItem(key, JSON.stringify({...defaultStorage}));
		}
	};
	return [storedValue, setValue];
};